import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { CheckCircle } from 'lucide-react';

const PaymentUpdateSuccess: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-gray-50 pt-20">
      <div className="container mx-auto px-4 max-w-md">
        <Card className="w-full">
          <CardContent className="p-6 text-center">
            <CheckCircle className="w-16 h-16 text-green-500 mx-auto mb-4" />
            <h1 className="text-2xl font-bold text-green-700 mb-2">
              Payment Method Updated!
            </h1>
            <p className="text-gray-600 mb-4">
              Your payment method has been successfully updated. Future payments for your subscription will use the new payment method.
            </p>
            <p className="text-sm text-gray-500">
              You can close this page now.
            </p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default PaymentUpdateSuccess;